import { registerProvider, type TextureProvider } from './provider';
import { imageEndpointProvider } from './provider';
import { EXAMPLE_PROMPTS, synthesiseFromPrompt } from './prompt';

/**
 * Texture sources: the Core Texture Pack, image import and prompt generation.
 */

/** The offline synthesiser, always available. */
export const promptSynthProvider: TextureProvider = {
  id: 'prompt-synth',
  name: 'Prompt synthesiser',
  description:
    'Builds a parametric relief from your words. Runs entirely in the browser, needs no key, and every slider stays editable afterwards.',

  isReady() {
    return true;
  },

  async generate(request) {
    return synthesiseFromPrompt(request.prompt, request.seed);
  },
};

let registered = false;

export function registerBuiltinProviders(): void {
  if (registered) return;
  registered = true;

  registerProvider(promptSynthProvider);
  registerProvider(imageEndpointProvider);
}

export { EXAMPLE_PROMPTS };
export * from './pack';
export * from './provider';
export * from './image';
export { synthesiseFromPrompt, analysePrompt } from './prompt';
